_collow.components.Image = class Image extends _collow.components.Base {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;
    this.getImages();
  }
  /** set images based on current width of the room */
  getImages = () => {
    if (!this.params.path) return;
    const devicePixelRatio = window.devicePixelRatio;
    const imageWidth = Math.ceil(this.root.width * devicePixelRatio);
    let imageHeight = Math.ceil(this.root.height * devicePixelRatio);

    this.root.src = this.params.path +
    `?${imageWidth && `w=${imageWidth}`}${
      this.params?.crop ? `&fit=crop&crop=entropy&fm=webp` : ""
    }&fm=webp`;

    // this.root.src =
    //   this.params.path +
    //   `?${imageWidth ? `w=${imageWidth}` : `h=${imageHeight}`}${
    //     this.params?.crop ? `&fit=crop&crop=entropy&fm=webp` : ""
    //   }&fm=webp`;
    this.root.alt = this.params.alt;
    this.root.title = this.params.title;
  };
};
